import { render } from "./FullReportTableUsers.vue?vue&type=template&id=b64c45e2&scoped=true"
import script from "./FullReportTableUsers.vue?vue&type=script&lang=js"
export * from "./FullReportTableUsers.vue?vue&type=script&lang=js"

import "./FullReportTableUsers.vue?vue&type=style&index=0&id=b64c45e2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b64c45e2"]])

export default __exports__